<template>
    <div :style="style"> 
    <pcbForm :option="option" v-model="formData"></pcbForm>
</div>

</template>
<script setup>
import { pcbForm } from '../main'
const props=defineProps({
    option:{
        type:Object,
        default:()=>({})
    },
    style:{
        type:Object,
        default:()=>({})
    }
})
const emit=defineEmits(["submit","reset","form-change"])
const formData=defineModel("form")
defineOptions({
    name:"pcb-form-self"
})
</script>
<style scoped>
:deep(.arco-form-item-content){
    background-color: #fff;
}
</style>
